import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h4","key":"svg-2"}],["path",{"d":"M17 17v5","key":"svg-3"}],["path",{"d":"M21 17v5","key":"svg-4"}]]

const IconFilter2Pause = createReactComponent('outline', 'filter-2-pause', 'Filter2Pause', __iconNode);

export default IconFilter2Pause;